import { render, staticRenderFns } from "./DenyApplicantMessage.vue?vue&type=template&id=78dacbe1&"
import script from "./DenyApplicantMessage.vue?vue&type=script&lang=js&"
export * from "./DenyApplicantMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports